import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__icons_perks_mjs_325d2b56__ from "../../icons/perks.mjs";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_096f7d9c__ from "../../../../common/pdsTv.mjs";
const main = (0, __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_096f7d9c__.pdsTv)({
    slots: {
        base: 'ptw-flex ptw-h-[20px] ptw-w-auto ptw-items-center ptw-rounded-pill ptw-bg-surface-heavy',
        wrapper: 'ptw-ml-3 ptw-pr-4 ptw-text-body-sm ptw-font-semibold ptw-text-primary'
    },
    variants: {
        theme: {
            white: {
                base: 'ptw-flex ptw-h-[20px] ptw-w-auto ptw-items-center ptw-rounded-pill ptw-bg-surface-base',
                wrapper: 'ptw-ml-3 ptw-pr-4 ptw-text-body-sm ptw-font-semibold ptw-text-[#E91C24]'
            },
            grey: {
                base: 'ptw-flex ptw-h-[20px] ptw-w-auto ptw-items-center ptw-rounded-pill ptw-bg-surface-heavy',
                wrapper: 'ptw-ml-3 ptw-pr-4 ptw-text-body-sm ptw-font-semibold ptw-text-surface-text'
            },
            red: {
                base: 'ptw-flex ptw-h-[20px] ptw-w-auto ptw-items-center ptw-rounded-pill ptw-bg-primary-tonal',
                wrapper: 'ptw-ml-3 ptw-pr-4 ptw-text-body-sm ptw-font-semibold ptw-text-surface-text'
            }
        }
    }
});
const UserPointsBadge = ({ points, theme = 'grey', className, style })=>{
    const { base, wrapper } = main({
        theme
    });
    const showPoints = void 0 !== points;
    const baseRingClasses = 'ptw-pointer-events-none ptw-absolute ptw-left-1/2 ptw-top-1/2 ptw-z-0 -ptw-translate-x-1/2 -ptw-translate-y-1/2 ptw-rounded-[99999px] ptw-border-solid ptw-border-primary-text';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "ptw-relative ptw-ml-3",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: `${baseRingClasses} ptw-h-[225%] ptw-w-[130%] ptw-opacity-[.10]`
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: `${baseRingClasses} ptw-h-[185%] ptw-w-[120%] ptw-opacity-[.20]`
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: `${baseRingClasses} ptw-h-[140%] ptw-w-[110%] ptw-opacity-[.30]`
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                style: style,
                className: base({
                    className
                }),
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__icons_perks_mjs_325d2b56__["default"], {
                        className: "ptw-ml-3",
                        width: 16.57
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: wrapper(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                children: showPoints ? `${points} pts` : 'Start Earning Points'
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const UserPointsBadge_UserPointsBadge = UserPointsBadge;
export { UserPointsBadge_UserPointsBadge as default };
